import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = {
  key: 0,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_15 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_16 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_EditUserAgenceModal = _resolveComponent("EditUserAgenceModal")!
  const _component_EditUserPassModal = _resolveComponent("EditUserPassModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.checkPermission('AddUser'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-user"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                  _createTextVNode(" Ajouter un utilisateur ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un utilisateur"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.users.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Nom et Prénom "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Téléphone "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Email "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Rôle "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Agence "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Sexe "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Statut "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
                    }, "Date création"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(user.nomComplet), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(user.telephone), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(user?.role?.nom), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(user?.agence?.nom), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(user.sexe), 1),
                      _createElementVNode("td", _hoisted_14, [
                        (user.etat =='Actif')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(user.etat), 1))
                          : _createCommentVNode("", true),
                        (user.etat =='Inactif')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(user.etat), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.format_date(user.createdAt)), 1),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", {
                            class: "badge text-white bg-primary fs-15 dropdown-toggle",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createTextVNode(" Actions "),
                            _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_20, [
                            (_ctx.checkPermission('AssignAgenceUser'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "#",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#EditUserAgenceModal",
                                    onClick: ($event: any) => (_ctx.openEditAgenceModal(user))
                                  }, [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("i", { class: "flaticon-compare lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Affecter une agence ", -1)
                                  ]))], 8, _hoisted_22)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPermission('EditPasswordUser'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "#",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#EditUserPassModal",
                                    onClick: ($event: any) => (_ctx.openEditPassModal(user))
                                  }, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Modifier le mot de passe ", -1)
                                  ]))], 8, _hoisted_24)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPermission('EditUser'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                  _createVNode(_component_router_link, {
                                    class: "dropdown-item d-flex align-items-center",
                                    to: { name: 'EditUserPage',params: { id: user.id } }
                                  }, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Modifier les informations ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPermission('DeleteUser'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                  (user.etat == 'Actif')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "dropdown-item d-flex align-items-center",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.desactiver(user))
                                      }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Désactiver ", -1)
                                      ]))], 8, _hoisted_27))
                                    : _createCommentVNode("", true),
                                  (user.etat == 'Inactif')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: "dropdown-item d-flex align-items-center",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (_ctx.desactiver(user))
                                      }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Activer ", -1)
                                      ]))], 8, _hoisted_28))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_EditUserAgenceModal, {
      selectedUser: _ctx.selectedUser,
      onClose: _ctx.rechercher
    }, null, 8, ["selectedUser", "onClose"]),
    _createVNode(_component_EditUserPassModal, { selectedUser: _ctx.selectedUser }, null, 8, ["selectedUser"])
  ], 64))
}